import Cleave from 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.i18n'

export default {
  bind(el, binding) {
    const input = el.querySelector('input')
    const keyup = () => {
      input.$vCleave.destroy()
      input.$vCleave = new Cleave(input, binding.value)
    }

    input.addEventListener('input', keyup)
    input.$vCleave = new Cleave(input, binding.value)
  },
  update(el, binding) {
    const input = el.querySelector('input')
    input.$vCleave.destroy()
    input.$vCleave = new Cleave(input, binding.value)
  },
  unbind(el) {
    const input = el.querySelector('input')
    input.$vCleave.destroy()
  }
}
